import { render, staticRenderFns } from "./CodeSublimeView.vue?vue&type=template&id=9853c1a4&scoped=true&"
import script from "./CodeSublimeView.vue?vue&type=script&lang=js&"
export * from "./CodeSublimeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9853c1a4",
  null
  
)

export default component.exports